'use client';

import styled from 'styled-components';

const OutsideBoxWrap = styled.div<{ $padding?: boolean }>`
  background: ${props => props.theme.palette.gray.light};
  border-top: 3px solid ${({ theme }) => theme.custom.colors.brand};
  margin-left: -45px;
  margin-right: -45px;
  ${({ $padding }) => $padding && 'padding: 30px 100px;'}

  ${({ theme }) => theme.breakpoints.down(1390)} {
    margin-left: -20px;
    margin-right: -20px;
    padding-left: 20px;
    padding-right: 20px;
    width: calc(100% + 40px);
  }

  ${({ theme }) => theme.breakpoints.down('lg')} {
    ${({ $padding }) => $padding && 'padding-left: 35px;'}
    ${({ $padding }) => $padding && 'padding-right: 35px;'}
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: block;
    ${({ $padding }) => $padding && 'padding: 40px 20px;'}
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 1.25rem;
  }
`;

interface OutsideBoxProps {
  children?: React.ReactNode;
}

/**
 * @todo component naming
 */
const OutsideBox: React.FC<OutsideBoxProps> = ({ children }) => {
  return (
    <OutsideBoxWrap $padding={children !== undefined}>
      {children}
    </OutsideBoxWrap>
  );
};

export default OutsideBox;
